import {useEffect} from 'react'
import {toastSelectors} from '../../store/toast/toastSelectors'
import {toastActions} from '../../store/toast/toastActions'
import {useWuShowToast, WuToast} from '@npm-questionpro/wick-ui-lib'

export const ShowToasterMessage = (): React.ReactElement => {
  const successMessage = toastSelectors.useSuccessMessage()
  const errorMessage = toastSelectors.useErrorMessage()
  const resetToast = toastActions.useResetToast()
  const {showToast} = useWuShowToast()

  useEffect(() => {
    if (successMessage) {
      showToast({
        message: successMessage,
        variant: 'success',
        position: 'top',
      })
      resetToast()
    }
    if (errorMessage) {
      showToast({
        message: errorMessage,
        variant: 'error',
        position: 'top',
      })
      resetToast()
    }
  }, [successMessage, errorMessage, resetToast, showToast])

  return <WuToast />
}
